import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../../shared/components/PortalLayout';
import { useAuth, userIsAdmin, userIsReviewer, userIsEngineer, userApruebaGastos } from '../../context/AuthContext';
import client from '../../api/client';
import SupervisorListPage from './SupervisorListPage';
import SupervisorDetailPage from './SupervisorDetailPage';
import AdminAllReceipts from '../admin/AdminAllReceipts';
import ReviewerListPage from './ReviewerListPage';
import ReviewerDashboard from './ReviewerDashboard';

function SupervisorTabs({ employees }) {
  const { user } = useAuth();
  const isRev = userIsReviewer(user);
  const isEng = userIsEngineer(user);

  // 🔴 V82.1 — QUIEN NO APRUEBA NO TIENE COLA: ve el ALCANCE.
  // El socio caia en `SupervisorListPage`, que pide `/api/receipt-items/assigned` -lo que a uno
  // le toca APROBAR-, y como no aprueba gastos la pantalla salia VACIA con "No hay items
  // asignados para revisar". La pantalla hacia lo que fue disenada para hacer; el error fue
  // mandarlo ahi. `AdminAllReceipts` filtra por ALCANCE (`/api/receipts`) y es solo lectura.
  if (!userApruebaGastos(user)) {
    return <AdminAllReceipts employees={employees} detailBasePath="/supervisor/receipt" />;
  }

  // Pure reviewer (not engineer/admin): show only pending_review receipts for final approval
  if (isRev && !isEng) {
    return <ReviewerListPage employees={employees} />;
  }

  // Engineer (or admin): show L1 approval queue
  return <SupervisorListPage employees={employees} />;
}

export default function SupervisorView() {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    client.get('/api/users/employees')
      .then(res => setEmployees(res.data))
      .catch(err => console.error('Failed to load employees:', err));
  }, []);

  return (
    <PortalLayout activeModule="gastos">
      <Routes>
        <Route index element={<SupervisorTabs employees={employees} />} />
        <Route path="dashboard" element={<ReviewerDashboard />} />
        <Route path="receipt/:id" element={<SupervisorDetailPage />} />
      </Routes>
    </PortalLayout>
  );
}
